import './components/ui/tailwind.scss';

import {createApp} from 'vue';
import App from './App.vue'
import router from './router';
//import store from './store';
import createAppStore from './store'

import createHttp from '@/components/ui/services/HttpInstanceService'
import createApi, {VueApi} from '@/api'
import clickOutside from "@/utils/clickOutside";
import Tokens from "@/components/ui/services/TokenService";

let http = createHttp();
/* без вариантов */
window.$http = http
/* дальше ок  */

let api = createApi(http);
let store = createAppStore(api);

router.beforeEach((to, from, next) => {

    const publicPages = ['/login', '/create', '/restore'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = Tokens.isLogged();
    //console.log(loggedIn);
    if (authRequired && !loggedIn) {
        return next('/login');
    }


    if ((to.path === '/login' || to.path === '/restore' || to.path === '/create') && loggedIn) {
        return next('/dashboard')
    }
    if (to.path === '/') {
        return next('/dashboard')
    }

    const requiredName = store.getters['account/requiredName']
    const requiredSchool = store.getters['school/requiredSchool']


    if (requiredName && to.name !== 'UserProfile') {
        next({name: 'UserProfile', params: {user_id: store.getters['account/id']}});
    } else if (requiredSchool && !requiredName && to.name !== 'UserSchools') {
        next({name: 'UserSchools', params: {user_id: store.getters['account/id']}});
    }
    next();
})


const app = createApp(App)
    .use(VueApi, api)
    .use(store)
    .use(router)
    .use(clickOutside)
/*/!* dayjs *!/
import dayjs from 'dayjs'

require('dayjs/locale/ru')
dayjs.locale('ru')
app.config.globalProperties.$dayjs = dayjs;*/
//import format from "@/components/ui/services/date-format/format"
import DateService from "@/components/ui/services/DateService";

//app.config.globalProperties.$format = format;
app.config.globalProperties.$date = DateService;

//import _ from 'lodash'

//app.config.globalProperties.$_ = _

/* end */
setHttpInterceptors(store, router, http);


import DefaultLayout from './layouts/DefaultLayout.vue';
import AuthLayout from './layouts/AuthLayout.vue';

app.component('default-layout', DefaultLayout);
app.component('auth-layout', AuthLayout);


/* ui */
import UiInputText from "@/components/ui/form/UiInputText";

app.component('ui-input-text', UiInputText);
import UiButton from "@/components/ui/button/UiButton";

app.component('ui-button', UiButton);

/* view components */

import PageHeader from "@/components/PageHeader";

app.component('PageHeader', PageHeader);
import PageContent from "@/components/PageContent";

app.component('PageContent', PageContent);


app.mount('#app');


function setHttpInterceptors(store, router, http) {
    http.interceptors.response.use(response => {
        /*if('errorSuppression' in response.config && response.status === 200){
            response.data = { ok: true, data: response.data };
        }*/

        return response;
        // return Promise.resolve(response)
    }, error => {

        const alertCodes = {
            403: {title: '403 Forbidden', text: 'Ограничение доступа клиента к текущему ресурсу.', timeout: 3000},
            404: {title: '404 Not Found', text: 'Запрошенный документ не найден на сервере.', timeout: 3000},
            405: {title: '405 Method Not Allowed', text: 'Метод не поддерживается.', timeout: 3000},
            500: {
                title: '500 Internal Server Error', text: 'Внутренняя ошибка сервера, попробуйте обновить страницу.'
            },
            502: {title: '502 Bad Gateway', text: 'Плохой ответ сервера, попробуйте обновить страницу.'},
            503: {title: '503 Service Unavailable', text: 'Сервис не доступен, попробуйте позже.'},
        };

        const status = error.response.status;

        if (status in alertCodes) {
            store.dispatch('alerts/error', alertCodes[status]);
        }

        if (status === 429) {
            let retryAfter = error.response.headers['retry-after'];

            store.dispatch('alerts/warning', {
                title: '429 Too Many Requests',
                timeout: retryAfter * 1000,
                text: `Слишком много запросов на сервер. Повторите через ${retryAfter} c.`
            })
        }

        if (status === 401) {
            store.dispatch('account/logout')
        }


        if (status === 422) {
            if ('errors' in error.response.data) {
                let errors = error.response.data.errors;
                let all = [];
                Object.keys(errors).map(function (key) {
                    errors[key].forEach(item => {
                        all.push(item)
                    });
                });
                errors._all = all;
                return Promise.reject(errors);
            }

        }

        /*if (!('errorSuppression' in error.config)) {
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }*/

        console.log('🥵 critical error', error);
        //return Promise.reject(error);


        /*if(error.response.status === 401 && error.config.silence401 !== true){
            //await
            store.dispatch('user/cleanUser');
            router.push({ name: 'login' }, function(){
                // document.location.reload(); // опционально, либо чистим склад
            });
        }*/


        /*

         let es = error.config.errorSuppression;

         if('exclude' in es && es.exclude.includes(error.response.status)){
             return Promise.reject(error);
         }


         if('text' in es){
             let alert = { text: `Ошибка ответа от сервера ${es.text}` };

             if('critical' in es){
                 alert.text += ' Рекомендуем перезагрузить страницу!';
             }
             else{
                 alert.timeout = 3000;
             }

             store.dispatch('alerts/add', alert);
         }

         return { data: { ok: false } };
         */

    });
}
